import { render, staticRenderFns } from "./ObservacionesCriticasWebApp.vue?vue&type=template&id=f8773756&"
import script from "./ObservacionesCriticasWebApp.vue?vue&type=script&lang=js&"
export * from "./ObservacionesCriticasWebApp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports